import { render, staticRenderFns } from "./PotentialSpacesSection.vue?vue&type=template&id=1def97c9&"
import script from "./PotentialSpacesSection.vue?vue&type=script&lang=js&"
export * from "./PotentialSpacesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports